import React, { useEffect, useState } from "react";
import { getBlog } from "../api/client";
import { useParams, Link } from "react-router-dom";
import { getImageUrl } from "../utils/imageUtils";


const BlogDetail = ({ settings, lang }) => {
    const { slug } = useParams();
    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getBlog(slug);
                setBlog(response.data);
            } catch (error) {
                console.error("Failed to fetch blog details:", error);
            } finally {
                setLoading(false);
            }
        };
        if (slug) fetchData();
    }, [slug]);

    const getText = (en, ar) => (lang === "en" ? en : ar);
    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader
    if (!loading && !blog) return <div className="text-center py-5">Blog post not found.</div>;

    return (
        <section className="py-5">
            <div className="container py-5">
                <div id="blog-content" className="row justify-content-center">
                    {loading ? (
                        <div className="col-12 py-5 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-9 bg-card px-lg-5 py-5 d-blog">
                            <img src={getImageUrl(blog.image, 'imgPro')} className="w-100 rounded-custom shadow-lg mb-5 object-fit-cover" style={{ height: '400px' }} alt="Blog Image" />
                            <div>
                                <small className="text-muted mb-3 d-block">{new Date(blog.created_at).toLocaleDateString()}</small>
                                <h1 className="fw-bold mb-4">{lang === 'en' ? blog.title_en : blog.title_ar}</h1>
                                <div className="lead text-muted mb-5">
                                    {lang === 'en' ? blog.content_en : blog.content_ar}
                                </div>
                                <hr />
                                <div className="d-flex justify-content-between align-items-center mt-4">
                                    <Link to="/blog" className="btn btn-outline-custom">
                                        {getText("Back to Blog", "العودة للمدونة")}
                                    </Link>
                                    <div className="d-flex gap-2">
                                        <button className="btn btn-sm btn-outline-custom rounded-circle p-2 shareBtn" onClick={() => {
                                            if (navigator.share) {
                                                navigator.share({
                                                    title: lang === 'en' ? blog.title_en : blog.title_ar,
                                                    text: lang === 'en' ? blog.content_en : blog.content_ar,
                                                    url: window.location.href,
                                                });
                                            }
                                        }}>
                                            <i className="ri-share-line"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default BlogDetail;
